module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/landing-desktop-produs-1.c67dbbcb.png";